import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './containers/App';
import './index.css';
import 'antd/dist/antd.css';

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);


// WEBPACK FOOTER //
// ./src/index.tsx